import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-inline-block" }
const _hoisted_2 = ["href", "textContent"]
const _hoisted_3 = ["href"]

import DocumentationHelper from "~/cabinet/vue/api/DocumentationHelper";
import WebhookSchemeDialog from "~/cabinet/vue/api/WebhookSchemeDialog.vue";
import HelpBlock from "~/cabinet/vue/interface/HelpBlock.vue";
import {RunExternalBotActionFrontendParamsWebhookInterface} from "~/cabinet/ts/data/events/ActionDescription";
import {ref} from "vue";


const __default__ = {
    name: "CustomBotHelp"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    customBotUrl: {},
    webhook: {}
  },
  setup(__props: any) {


let props = __props;

let webhookSchemeDialogVisible = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HelpBlock, null, {
      default: _withCtx(() => [
        _createElementVNode("p", null, [
          _createElementVNode("span", _hoisted_1, [
            _cache[2] || (_cache[2] = _createTextVNode(" Мы будем отправлять уведомление о новом сообщении для вашего бота на URL, который вы указали в настройках интеграции", -1)),
            (__props.customBotUrl)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(":")
                ], 64))
              : _createCommentVNode("", true)
          ]),
          (__props.customBotUrl)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: __props.customBotUrl,
                textContent: _toDisplayString(__props.customBotUrl),
                style: {"white-space":"nowrap"},
                class: "text-truncate d-inline-block mw-100"
              }, null, 8, _hoisted_2))
            : _createCommentVNode("", true)
        ]),
        (__props.webhook)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("p", null, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  plain: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(webhookSchemeDialogVisible) //@ts-ignore
 ? webhookSchemeDialogVisible.value = true : webhookSchemeDialogVisible = true))
                }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode(" Посмотреть формат уведомлений ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              (_unref(webhookSchemeDialogVisible))
                ? (_openBlock(), _createBlock(WebhookSchemeDialog, {
                    key: 0,
                    visible: _unref(webhookSchemeDialogVisible),
                    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_isRef(webhookSchemeDialogVisible) ? (webhookSchemeDialogVisible).value = $event : webhookSchemeDialogVisible = $event)),
                    "platform-id": __props.webhook.platformId,
                    "auth-primary-id": __props.webhook.authPrimaryId,
                    "webhook-id": __props.webhook.webhookId,
                    "data-only": "",
                    "webhook-descr": "Формат уведомлений о новом сообщении"
                  }, null, 8, ["visible", "platform-id", "auth-primary-id", "webhook-id"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(HelpBlock, null, {
      default: _withCtx(() => [
        _cache[5] || (_cache[5] = _createElementVNode("p", null, "Для того, чтобы отправить ответ клиенту, используйте token, который вы получили в webhook от нас.", -1)),
        _createElementVNode("p", null, [
          _createElementVNode("a", {
            href: _unref(DocumentationHelper).getUrl(['customBot'], 'tag/CustomBot'),
            target: "_blank"
          }, [
            _createVNode(_component_el_button, {
              type: "primary",
              plain: ""
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode(" Посмотреть документацию по Rest API ", -1)
              ]))]),
              _: 1
            })
          ], 8, _hoisted_3)
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})